export default {
  'SAVE_CLIENT' (state, payload) {
    state.data = JSON.parse(JSON.stringify(payload))
  },
  'CLEAR_CLIENT' (state) {
    state.data = []
  },
  'DELETE_CLIENT' (state) {
    state.data = null
  },
  'SET_CLIENT' (state, payload) {
    state.data = JSON.parse(JSON.stringify(payload))
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/client/mutations.js